module.exports = __webpack_public_path__ + "static/media/kjlogo.ac0c8181.png";